import { render, staticRenderFns } from "./PACustomers.vue?vue&type=template&id=96482dbc&scoped=true"
import script from "./PACustomers.vue?vue&type=script&lang=js"
export * from "./PACustomers.vue?vue&type=script&lang=js"
import style0 from "./PACustomers.vue?vue&type=style&index=0&id=96482dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96482dbc",
  null
  
)

export default component.exports